import React from 'react';

import { createIcon } from '../OriginIcon/iconHelper';
import { IOriginIconProps } from '../OriginIcon';

const Icon = createIcon(
  'SolarPanelIcon',
  <React.Fragment>
    <rect style={{ fill: '#FFFFFF' }} width="176" height="176" />
    <g id="Sun">
      <path
        style={{ fill: '#FFC72C' }}
        d="M45.5 66.8c9.5 0.1 18.1-5.6 21.8-14.4 3.7-8.8 1.7-18.9-5.1-25.6 -6.7-6.7-16.9-8.7-25.6-5.1C27.8 25.4 22.1 34 22.2 43.5c0.1 12.9 10.6 23.3 23.5 23.3"
      />
      <polygon
        style={{ fill: '#FFC72C' }}
        points="8.7 46.9 15.4 46.9 15.4 40.2 8.7 40.2 2 40.2 2 46.9 "
      />
      <polygon
        style={{ fill: '#FFC72C' }}
        points="82.3 46.9 89 46.9 89 40.2 82.3 40.2 75.6 40.2 75.6 46.9 "
      />
      <polygon
        style={{ fill: '#FFC72C' }}
        points="17.1 19.9 21.9 24.6 26.6 19.9 21.9 15.1 17.1 10.4 12.4 15.1 "
      />
      <polygon
        style={{ fill: '#FFC72C' }}
        points="69.1 71.9 73.9 76.7 78.7 71.9 73.9 67.2 69.1 62.4 64.4 67.2 "
      />
      <polygon
        style={{ fill: '#FFC72C' }}
        points="42.2 6.7 42.2 13.5 48.9 13.5 48.9 6.7 48.9 0 42.2 0 "
      />
      <polygon
        style={{ fill: '#FFC72C' }}
        points="42.2 80.3 42.2 87 48.9 87 48.9 80.3 48.9 73.6 42.2 73.6 "
      />
      <polygon
        style={{ fill: '#FFC72C' }}
        points="69.1 15.1 64.4 19.9 69.1 24.6 73.9 19.9 78.7 15.1 73.9 10.4 "
      />
      <polygon
        style={{ fill: '#FFC72C' }}
        points="17.1 67.2 12.4 71.9 17.1 76.7 21.9 71.9 26.6 67.2 21.9 62.4 "
      />
    </g>
    <g id="Solar_Panel">
      <rect x="103" y="136" style={{ fill: '#D5D5D5' }} width="10" height="40" />
      <rect x="71" y="166" style={{ fill: '#D5D5D5' }} width="74" height="10" />
      <rect x="42" y="40" style={{ fill: '#D5D5D5' }} width="132" height="100" />
      <rect x="47" y="45.3" style={{ fill: '#0A5FD2' }} width="27" height="27" />
      <rect x="47" y="76.4" style={{ fill: '#0A5FD2' }} width="27" height="27" />
      <rect x="47" y="108.4" style={{ fill: '#0A5FD2' }} width="27" height="27" />
      <rect x="78.7" y="45.3" style={{ fill: '#0A5FD2' }} width="27" height="27" />
      <rect x="78.7" y="76.4" style={{ fill: '#0A5FD2' }} width="27" height="27" />
      <rect x="78.7" y="108.4" style={{ fill: '#0A5FD2' }} width="27" height="27" />
      <rect x="110.3" y="45.3" style={{ fill: '#0A5FD2' }} width="27" height="27" />
      <rect x="110.3" y="76.4" style={{ fill: '#0A5FD2' }} width="27" height="27" />
      <rect x="110.3" y="108.4" style={{ fill: '#0A5FD2' }} width="27" height="27" />
      <rect x="142" y="45.3" style={{ fill: '#0A5FD2' }} width="27" height="27" />
      <rect x="142" y="76.4" style={{ fill: '#0A5FD2' }} width="27" height="27" />
      <rect x="142" y="108.4" style={{ fill: '#0A5FD2' }} width="27" height="27" />
    </g>
  </React.Fragment>
);

export const SolarPanelIcon = (props: IOriginIconProps) => (
  <Icon viewBox="0 0 176 176" {...props} />
);
